import Footer from "../Footer/Footer";
import Header from "../Header/Navbar"
import './PrivacyPolicy.css'


const PrivacyPolicyPage:React.FC = () => {
  return (
    <>
  
    <div className="privacyPolicySection">
      <h2>Privacy Policy</h2>
      <p>Contact us at: <a href="mailto:customer.care@gangasupermarket.in">customer.care@gangasupermarket.in</a></p>

      <h3>1. Information We Collect</h3>
      <ul>
        <li>Personal information like name, email, address, phone number, etc.</li>
        <li>Details provided during sign-up, checkout, or payment.</li>
      </ul>

      <h3>2. How We Use Your Information</h3>
      <ul>
        <li>To provide order processing and customer service.</li>
        <li>To send communications and resolve complaints.</li>
        <li>To comply with legal obligations if required.</li>
        <li>To share relevant information with third-party service providers (with consent).</li>
      </ul>

      <h3>3. Hosting & Storage</h3>
      <ul>
        <li>Our store is hosted on <strong>Google.com</strong>.</li>
        <li>Your data is securely stored on Google servers.</li>
      </ul>

      <h3>4. Consent</h3>
      <ul>
        <li>By using our site, you consent to data collection and processing.</li>
        <li>You can withdraw consent anytime by contacting us.</li>
      </ul>

      <h3>5. Third-Party Services</h3>
      <ul>
        <li>We may use services like payment gateways, which have their own privacy policies.</li>
        <li>Once you leave our store or are redirected, this policy no longer applies.</li>
      </ul>

      <h3>6. Payments</h3>
      <ul>
        <li>Payments processed via third-party gateways are PCI-DSS compliant.</li>
        <li>Payment data is stored only as long as needed to complete the transaction.</li>
      </ul>

      <h3>7. Legal Compliance</h3>
      <ul>
        <li>We may preserve or disclose information to comply with legal requirements.</li>
        <li>We aim to protect against fraud and security issues.</li>
      </ul>

      <h3>8. Information Security</h3>
      <ul>
        <li>Your personal data is secured using industry-standard practices.</li>
        <li>We cannot guarantee 100% security over the internet.</li>
        <li>You are responsible for protecting your account credentials.</li>
      </ul>

      <h3>9. Changes to This Policy</h3>
      <ul>
        <li>We may update the Privacy Policy periodically.</li>
        <li>Continued use of the site means acceptance of the updated policy.</li>
      </ul>

      <h3>10. Contact</h3>
      <p>If you have questions or comments, please contact us at the address mentioned above.</p>
    </div>
    <Footer/>
     </>
  );
};

export default PrivacyPolicyPage;
